module.exports = __webpack_public_path__ + "img/rang10.c915295b.png";